import cookiePopup from '@/assets/modules/modals/cookiePopup.png';
import whatsappPopup from '@/assets/modules/modals/whatsappPopup.png';
import optinPopup from '@/assets/modules/modals/optinPopup.jpg';
import bannerPopup from '@/assets/modules/modals/bannerPopup.png';
import warningPopup from '@/assets/modules/modals/warningPopup.png';
import countdownPopup from '@/assets/modules/modals/countdownPopup.png';

import moduleCategory from '@/store/dicts/modalModuleCategory';
import isWithinLast30Days from '@/helpers/isWithinLast30Days';

const thirtyDaysFromNow = new Date(
  Number(new Date()) + 1000 * 60 * 60 * 24 * 30,
);

function orderList(list) {
  return list.sort((itemA, itemB) => itemA.name.localeCompare(itemB.name));
}

function newFirst(list) {
  return list.sort((itemA, itemB) => {
    if (!!itemA.isNew === !!itemB.isNew) {
      return 0;
    }

    return itemB.isNew ? 1 : -1;
  });
}

const presetList = [
  {
    category: [moduleCategory.POPUP],
    name: 'Pop-up de cookies',
    module: 'CookiePopup',
    image: cookiePopup,
    data: {
      text: '<p>Utilizamos <strong>cookies</strong> para coletar dados que ajudam a melhorar sua experiência, customizar nossa publicidade e aprimorar nossos serviços.</p>',
    },
  },
  {
    category: [moduleCategory.POPUP],
    name: 'Botão flutuante de Whatsapp',
    module: 'WhatsappPopup',
    image: whatsappPopup,
    createdAt: '2024/03/28',
    data: {
      primaryColor: '#25D366',
    },
  },
  {
    category: [moduleCategory.POPUP],
    name: 'Balão de avisos',
    module: 'WarningPopup',
    image: warningPopup,
    createdAt: '2024/06/24',
    data: {
      title: 'Tem reserva para os próximos meses?',
      text: 'Fique tranquilo. Sabemos que o momento é delicado, por isso flexibilizamos nossas políticas de cancelamento e reembolso. Se desejar reagendar a sua viagem, entre em contato com a gente! Ficaremos muito felizes em recebê-lo no futuro.',
      linkLabel: 'Reagendar minha viagem',
    },
  },
  {
    category: [moduleCategory.POPUP],
    name: 'Pop-up de opt-in',
    module: 'OptinPopup',
    image: optinPopup,
    isEnabled({ hasCRMIntegration }) {
      return hasCRMIntegration;
    },
    data: {
      title: 'Cadastre-se agora e aproveite!',
      subtitle: 'Receba antes as nossas melhores tarifas.',
      consentText: 'Aceito receber comunicações e ofertas.',
      successMessage: 'Obrigado pelo seu cadastro!',
      backgroundColor: '#FFFFFF',
      textColor: '#000000',
      ctaColor: '#3E9AA6',
      ctaLabel: 'Quero receber!',
      imageDesk:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/default/1639755242635-modal-background.jpg',
      triggerType: 'delay',
      delayToShow: 5,
    },
  },
  {
    category: [moduleCategory.POPUP],
    name: 'Pop-up de banner',
    module: 'BannerPopup',
    image: bannerPopup,
    data: {
      imageDesk:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas-imagens-popup-banner/1653675345578-banner-popup-desk.png',
      useDifferentMobileBgImage: true,
      imageMobile:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/nicolas-imagens-popup-banner/1653675356423-banner-popup-mobile.png',
      triggerType: 'delay',
      delayToShow: 5,
    },
  },
  {
    category: [moduleCategory.POPUP],
    name: 'Pop-up contador',
    module: 'CountdownPopup',
    image: countdownPopup,
    data: {
      title: 'Últimos momentos para aproveitar nossa oferta',
      text: 'Não perca tempo e cadastre-se',
      linkLabel: 'Quero reservar',
      textColor: '#000000',
      titleWeight: '600',
      ctaColor: '#3E9AA6',
      timerColor: '#3E9AA6',
      buttonTextColor: '#FFFFFF',
      imageDesk:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/popup-contador/1725390100805-contador.png',
      useDifferentMobileBgImage: true,
      imageMobile:
        'https://letsimage.s3.sa-east-1.amazonaws.com/editor/homolog/pt/popup-contador/1725390351569-contador-mobile.png',
      triggerType: 'delay',
      delayToShow: 5,
      date: thirtyDaysFromNow.toISOString(),
    },
  },
].map((preset) => ({
  ...preset,
  isNew: isWithinLast30Days(preset.createdAt),
  isUpdated: isWithinLast30Days(preset.updatedAt),
}));

export default newFirst(orderList(presetList));
